import { useState } from 'react';

export function useFilters<T>(defaultFilters: T = null) {
    const [filters, setFilters] = useState<T>(defaultFilters);
    return { filters, setFilters };
}
